
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import KnowledgeSearch from "./KnowledgeSearch";
import KnowledgeCollectionsList from "./KnowledgeCollectionsList";
import KnowledgeArticleView from "./KnowledgeArticleView";
import { KnowledgeArticle, KnowledgeCollection } from "./types";

interface KnowledgeBaseFullProps {
  collections: KnowledgeCollection[];
  selectedCollection: string | null;
  selectedArticle: KnowledgeArticle | null;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  setSelectedCollection: (id: string | null) => void;
  handleSearch: () => void;
  handleArticleSelection: (article: KnowledgeArticle) => void;
  setSelectedArticle: (article: KnowledgeArticle | null) => void;
}

const KnowledgeBaseFull = ({
  collections,
  selectedCollection,
  selectedArticle,
  searchQuery,
  setSearchQuery,
  setSelectedCollection,
  handleSearch,
  handleArticleSelection,
  setSelectedArticle,
}: KnowledgeBaseFullProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <div className="md:col-span-1">
        <div className="mb-4">
          <KnowledgeSearch
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleSearch={handleSearch}
          />
        </div>
        <Tabs
          defaultValue={selectedCollection || collections[0]?.id}
          orientation="vertical"
          className="w-full"
          onValueChange={(value) => setSelectedCollection(value)}
        >
          <TabsList className="w-full flex flex-col items-stretch h-auto bg-transparent space-y-1">
            {collections.map((collection) => (
              <TabsTrigger
                key={collection.id}
                value={collection.id}
                className="justify-start text-left px-3 py-2 h-auto data-[state=active]:bg-muted"
              >
                {collection.name}
                <span className="ml-auto text-xs text-muted-foreground">
                  {collection.articles.length}
                </span>
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>

      <div className="md:col-span-3">
        {selectedArticle ? (
          <KnowledgeArticleView
            article={selectedArticle}
            onBack={() => setSelectedArticle(null)}
          />
        ) : (
          <div>
            {collections
              .filter(
                (collection) =>
                  selectedCollection === null || collection.id === selectedCollection
              )
              .map((collection) => (
                <div key={collection.id} className="mb-8">
                  <h2 className="text-2xl font-bold mb-4">{collection.name}</h2>
                  {collection.description && (
                    <p className="text-muted-foreground mb-4">{collection.description}</p>
                  )}
                  <KnowledgeCollectionsList
                    collections={[collection]}
                    onArticleSelect={handleArticleSelection}
                  />
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default KnowledgeBaseFull;
